export const CONNECT_INBOX_REQUEST_GROUP = 'BLOG_GOOGLE_DRIVE_INTEGRATION';
export const googleDocImportIdentifierTag = `<b id="google-docs-import">`;